<template>
  <div class="maze-container">
    <div class="pt-3">
      <label for="block-type">Select block type:</label>
      <select v-model="selectedBlockType" id="block-type">
        <option
          v-for="(block, index) in blockTypes"
          :key="`block-${index}`"
          :value="index"
        >
          {{ block.name }}
        </option>
      </select>
    </div>
    <div class="pt-3">
      <label for="rows">Rows:</label>
      <input
        type="number"
        id="rows"
        v-model.number="mazeRows"
        min="1"
        max="50"
        step="1"
      />
      <label for="columns">Columns:</label>
      <input
        type="number"
        id="columns"
        v-model.number="mazeColumns"
        min="1"
        max="50"
        step="1"
      />
    </div>
    <div class="pt-3" style="">
      <h3>Create a new reward block:</h3>
      <label for="new-block-name">Name:</label>
      <input type="text" id="new-block-name" v-model="newBlockName" />

      <label for="new-block-image-url">Image URL:</label>
      <input type="text" id="new-block-image-url" v-model="newBlockImageUrl" />

      <label for="new-block-ticker">Ticker:</label>
      <input type="text" id="new-block-ticker" v-model="newBlockTicker" />

      <label for="new-block-nonce">Nonce:</label>
      <input
        type="number"
        id="new-block-nonce"
        v-model.number="newBlockNonce"
      />

      <label for="new-block-quantity">Quantity:</label>
      <input
        type="number"
        id="new-block-quantity"
        v-model.number="newBlockQuantity"
      />

      <label for="new-block-prize-type">Prize Type:</label>
      <select v-model="newBlockPrizeType" id="new-block-prize-type">
        <option value="Normal">Normal</option>
        <option value="Finish">Finish</option>
      </select>

      <button
        @click="
          addNewBlock(
            newBlockName,
            newBlockImageUrl,
            newBlockTicker,
            newBlockNonce,
            newBlockQuantity,
            newBlockPrizeType
          )
        "
      >
        Add Reward Block
      </button>
    </div>
    <div
      class="grid pt-3"
      @mousedown.left="startDrawing"
      @mousemove="handleMouseMove"
      @mouseup="stopDrawing"
      @mouseleave="stopDrawing"
    >
      <div
        v-for="(row, rowIndex) in maze"
        :key="`row-${rowIndex}`"
        class="row"
        :data-row="rowIndex"
      >
        <div
          v-for="(cell, cellIndex) in row"
          :key="`cell-${cellIndex}`"
          :class="cellClass(cell)"
          :data-cell="cellIndex"
          @mousedown.left.stop="
            toggleBlock(rowIndex, cellIndex, selectedBlockType)
          "
        >
          <img v-if="cell !== 0" :src="blockTypes[cell].imageUrl" />
        </div>
      </div>
    </div>
    <button @click="generateMaze">Generate new maze</button>
    <button @click="setMaze">Set Maze</button>
    <button @click="getMaze">Log Maze</button>
  </div>
</template>

<script>
import { ref } from "vue";
import {
  generateRandomMaze,
  block_prize,
  mazeToHexString,
  mazeToMatrixOfBlockTypes,
} from "@/utils/maze-generator";
import TrapImage from "@/assets/images/actions/burn.png";
import WallImage from "@/assets/images/actions/wall.png";
import NiftyBitImage from "@/assets/images/tokens/niftybit.png";
import PlayerImage from "@/assets/images/rexface.svg";
import PortalImage from "@/assets/images/actions/portal.png";
import GiftImage from "@/assets/images/actions/gift.png";
import Door1Image from "@/assets/images/pixel/niftyking/door-1.png";
import Door2Image from "@/assets/images/pixel/niftyking/door-2.png";
import Door3Image from "@/assets/images/pixel/niftyking/door-3.png";
import Door4Image from "@/assets/images/pixel/niftyking/door-4.png";
import Door5Image from "@/assets/images/pixel/niftyking/door-5.png";
import Door6Image from "@/assets/images/pixel/niftyking/door-6.png";
import Key1Image from "@/assets/images/pixel/niftyking/key-1.gif";
import Key2Image from "@/assets/images/pixel/niftyking/key-2.gif";
import Key3Image from "@/assets/images/pixel/niftyking/key-3.gif";
import Key4Image from "@/assets/images/pixel/niftyking/key-4.gif";
import Key5Image from "@/assets/images/pixel/niftyking/key-5.gif";
import Key6Image from "@/assets/images/pixel/niftyking/key-6.gif";
import useMazeStore from "@/store/mazeStore";

export default {
  setup() {
    const mazeStore = useMazeStore();

    // Call init() method from the store
    mazeStore.init();

    const blockSize = ref(32); // Update the block size
    const blockTextureUrl = ref(WallImage);
    const mazeRows = ref(10);
    const mazeColumns = ref(10);
    const maze = ref(generateRandomMaze(10, 10));
    const isDrawing = ref(false);
    const lastCell = ref(null);
    const selectedBlockType = ref(1);
    const newBlockName = ref("");
    const newBlockImageUrl = ref("");
    const newBlockTicker = ref("");
    const newBlockNonce = ref(0);
    const newBlockQuantity = ref(0);
    const newBlockPrizeType = ref("");
    const mazeHex = ref("");

    const getMaze = async () => {
      await mazeStore.getMaze();
    };

    const setMaze = () => {
      let maze_hex = getMazeHex();
      console.log("HEX MAZE:");
      console.log(maze_hex);
      mazeStore.setMaze(maze_hex);
    };

    const getMazeHex = () => {
      console.log("doing it.");
      console.log("this is the maze:");
      let blockTypeMatrix = mazeToMatrixOfBlockTypes(maze.value, blockTypes); // Call the modified function
      console.log(blockTypeMatrix);
      mazeHex.value = mazeToHexString(blockTypeMatrix);
      return mazeHex.value;
    };

    const blockTypes = [
      { name: "Path", imageUrl: "", type: "None" },
      { name: "Wall", imageUrl: WallImage, type: "Wall" },
      { name: "Trap", imageUrl: TrapImage, type: "Trap" },
      {
        name: "NFTBIT",
        imageUrl: NiftyBitImage,
        ticker: "NFTBIT-6b732e",
        nonce: 0,
        quantity: 1000000000000000000,
        type: "Reward",
        prizeType: "Normal",
      },
      { name: "Player", imageUrl: PlayerImage, type: "None" },
      { name: "Reward", imageUrl: GiftImage, type: "Reward" },
      { name: "Door-1", imageUrl: Door1Image, id: 1, type: "Door" },
      { name: "Door-2", imageUrl: Door2Image, id: 2, type: "Door" },
      { name: "Door-3", imageUrl: Door3Image, id: 3, type: "Door" },
      { name: "Door-4", imageUrl: Door4Image, id: 4, type: "Door" },
      { name: "Door-5", imageUrl: Door5Image, id: 5, type: "Door" },
      { name: "Door-6", imageUrl: Door6Image, id: 6, type: "Door" },
      { name: "Key-1", imageUrl: Key1Image, id: 1, type: "Key" },
      { name: "Key-2", imageUrl: Key2Image, id: 2, type: "Key" },
      { name: "Key-3", imageUrl: Key3Image, id: 3, type: "Key" },
      { name: "Key-4", imageUrl: Key4Image, id: 4, type: "Key" },
      { name: "Key-5", imageUrl: Key5Image, id: 5, type: "Key" },
      { name: "Key-6", imageUrl: Key6Image, id: 6, type: "Key" },
    ];

    const cellClass = (cell) => {
      return {
        cell: true,
        "cell-path": cell === 0,
      };
    };

    const startDrawing = () => {
      isDrawing.value = true;
    };

    const handleMouseMove = (event) => {
      if (isDrawing.value) {
        const cellElement = event.target.closest(".cell");
        if (cellElement && cellElement !== lastCell.value) {
          const rowIndex = parseInt(
            cellElement.parentElement.getAttribute("data-row")
          );
          const cellIndex = parseInt(cellElement.getAttribute("data-cell"));
          toggleBlock(rowIndex, cellIndex, selectedBlockType.value);
          lastCell.value = cellElement;
        }
      }
    };

    const stopDrawing = () => {
      isDrawing.value = false;
      lastCell.value = null;
    };

    const toggleBlock = (rowIndex, cellIndex, blockType) => {
      if (maze.value[rowIndex][cellIndex] === blockType) {
        maze.value[rowIndex][cellIndex] = 0; // Set the cell to a path (empty)
      } else {
        maze.value[rowIndex][cellIndex] = blockType;
      }
    };

    const generateMaze = () => {
      maze.value = generateRandomMaze(mazeRows.value, mazeColumns.value);
    };

    function createRewardBlock(
      name,
      imageUrl,
      ticker,
      nonce,
      quantity,
      prizeType
    ) {
      return {
        name,
        imageUrl,
        ticker,
        nonce,
        quantity,
        type: "Reward",
        prizeType,
      };
    }

    const addNewBlock = (
      blockName,
      blockImageUrl,
      blockTicker,
      blockNonce,
      blockQuantity,
      blockPrizeType
    ) => {
      let newBlock = createRewardBlock(
        blockName,
        blockImageUrl,
        blockTicker,
        blockNonce,
        blockQuantity,
        blockPrizeType
      );
      blockTypes.push(newBlock);
      console.log("New block:");
      console.log(newBlock);
      // Clear input fields after adding the block
      newBlockName.value = "";
      newBlockImageUrl.value = "";
      newBlockTicker.value = "";
      newBlockNonce.value = 0;
      newBlockQuantity.value = 0;
    };

    /*
    05010000000d4e46544249542d3931653365310000000000000000000000080de0b6b3a7640000
    05010000000d4853574f4c462d393165336531000000000000007b000000080de0b6b3a7640000
    */
    return {
      maze,
      cellClass,
      startDrawing,
      handleMouseMove,
      stopDrawing,
      toggleBlock,
      generateMaze,
      getMazeHex,
      setMaze,
      getMaze,
      mazeRows,
      mazeColumns,
      blockTypes,
      selectedBlockType,
      blockSize,
      blockTextureUrl,
      newBlockName,
      newBlockImageUrl,
      newBlockTicker,
      newBlockNonce,
      newBlockQuantity,
      addNewBlock,
    };
  },
};
</script>

<style scoped>
.maze-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0px !important;
}

.grid {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.row {
  display: flex;
}

.cell {
  user-select: none;
  width: 20px;
  height: 29px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cell-path {
  background-color: #fff;
}

img {
  width: 25px;
}
</style>
